<div class="forgot-password-container">
  <div class="forgot-password-card">
    <div class="forgot-password-header">
      <h1>Forgot Password?</h1>
      <p>Enter your email to receive a password reset link</p>
    </div>

    @if (errorMessage) {
      <div class="alert-message error-message">
        {{ errorMessage }}
      </div>
    }

    @if (successMessage) {
      <div class="alert-message success-message">
        {{ successMessage }}
      </div>
    }

    <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="forgot-password-form">
      <div class="form-group">
        <label for="email">Email</label>
        <input
          type="email"
          id="email"
          formControlName="email"
          placeholder="Enter your email"
          [class.error]="email?.invalid && email?.touched"
          />
        @if (email?.invalid && email?.touched) {
          <div class="error-message">
            @if (email?.errors?.['required']) {
              <span>Email is required</span>
            }
            @if (email?.errors?.['email']) {
              <span>Invalid email format</span>
            }
          </div>
        }
      </div>

      <button
        type="submit"
        class="btn-primary"
        [disabled]="forgotPasswordForm.invalid || loading"
        >
        {{ loading ? 'Sending...' : 'Send Reset Link' }}
      </button>

      <div class="back-to-login">
        Remember your password? <a routerLink="/login">Login</a>
      </div>
    </form>
  </div>
</div>
